import React, { useRef } from "react";
import { gsap, useGSAP, EASE, prefersReducedMotion } from "../../lib/gsap";

/**
 * Media is exposed rather than faded: a hard edge wipes across it with a
 * hard scan line riding the boundary, like a plate being read by a scanner.
 * Replaces the usual fade-and-parallax, which every site has.
 */
const MaskMedia = ({ children, className = "", from = "left", start = "top 82%" }) => {
  const scope = useRef(null);

  useGSAP(
    () => {
      if (prefersReducedMotion()) return undefined;

      const media = scope.current.querySelector("[data-mask-body]");
      const scan = scope.current.querySelector("[data-scan]");
      const hidden =
        from === "left" ? "inset(0% 100% 0% 0%)" : "inset(0% 0% 0% 100%)";

      const tl = gsap.timeline({
        scrollTrigger: { trigger: scope.current, start, once: true },
      });

      tl.fromTo(
        media,
        { clipPath: hidden },
        { clipPath: "inset(0% 0% 0% 0%)", duration: 1.05, ease: EASE.io },
        0
      )
        .fromTo(
          scan,
          { xPercent: from === "left" ? -100 : 100, opacity: 1 },
          { xPercent: from === "left" ? 100 : -100, duration: 1.05, ease: EASE.io },
          0
        )
        .to(scan, { opacity: 0, duration: 0.2 }, 0.95);

      return () => tl.kill();
    },
    { scope }
  );

  return (
    <div ref={scope} className={`relative overflow-hidden ${className}`}>
      <div data-mask-body className="h-full w-full">
        {children}
      </div>
      <span
        data-scan
        aria-hidden="true"
        className="pointer-events-none absolute inset-y-0 left-0 w-[2px] opacity-0"
        style={{ background: "var(--flare)" }}
      />
    </div>
  );
};

export default MaskMedia;
